export class Ingreso {
    idingreso?:string
    idliquida?:string
    concepto?:string
    idfactura?:string
    total?:number
    fecha?:string
    hora?:string
    estado?:string
    idtipogasto?:any
}
